import { Divider } from "primereact/divider";
import SessionsCarousel from "../../../../../components/sharedComponents/SessionsCarousel";
import { useState } from "react";
import { Card } from "primereact/card";
import { TabView, TabPanel } from "primereact/tabview";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import VideoAudioXmotType from "./resultsComponents/VideoAudioXmotType/VideoAudioXmotType";
import SurveyXmotType from "./resultsComponents/SurveyXmotType/SurveyXmotType";
import PhotoOnlyXmotType from "./resultsComponents/PhotoOnlyXmotType/PhotoOnlyXmotType";

const ResultsTab = ({ study_id, token, clientId }) => {
  const [selectedSession, setSelectedSession] = useState(0);

  return (
    <div className="text-start">
      {/* <VideoAudioXmotType /> */}
      {/* if Audio session */}
      {/* <VideoAudioXmotType isAudioSession={true} /> */}
      <SurveyXmotType study_id={study_id} token={token} clientId={clientId} />
      {/* <PhotoOnlyXmotType /> */}
    </div>
  );
};

export default ResultsTab;
